module.exports = __webpack_public_path__ + "img/ctc-event.739f9254.png";